export default __webpack_public_path__ + "static/media/query.cff6db3a.jpg";